module.exports = __webpack_public_path__ + "media/images/photos/1-2bf62b72ac89cec7b593919f8903d644.jpg";